"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _userflow = _interopRequireDefault(require("../../../../styles/userflow"));
var _emailUtils = require("../../../../utils/emailUtils");
var _Partner = require("../../contexts/Partner");
var _Spacer = _interopRequireDefault(require("../common/Spacer"));
var _Grid = _interopRequireDefault(require("../common/Grid"));
var _Link = _interopRequireDefault(require("../common/Link"));
var _Container = _interopRequireDefault(require("../Container"));
var _templateObject;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Webmail = function Webmail(_ref) {
  var link = _ref.link;
  var _useContext = (0, _react.useContext)(_Partner.PartnerContext),
    isWl = _useContext.isWl;
  var styles = {
    cell: {
      fontSize: '10px',
      color: _userflow["default"].colors.greyLight
    },
    align: {
      textAlign: 'right'
    },
    link: {
      color: _userflow["default"].colors.greyLight
    }
  };
  var linkCellStyles = _objectSpread(_objectSpread({}, styles.cell), styles.align);
  return /*#__PURE__*/_react["default"].createElement(_Container["default"], {
    className: "webmail"
  }, /*#__PURE__*/_react["default"].createElement(_Spacer["default"], {
    size: 8
  }), /*#__PURE__*/_react["default"].createElement(_Grid["default"], null, /*#__PURE__*/_react["default"].createElement(_Grid["default"].Row, null, /*#__PURE__*/_react["default"].createElement(WebmailCell, {
    style: styles.cell
  }, !isWl && 'Разумный способ путешествовать'), /*#__PURE__*/_react["default"].createElement(WebmailCell, {
    style: linkCellStyles
  }, link && /*#__PURE__*/_react["default"].createElement(_Link["default"], {
    href: link,
    style: styles.link
  }, "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u043F\u0438\u0441\u044C\u043C\u043E \u0432 \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0435")))), /*#__PURE__*/_react["default"].createElement(_Spacer["default"], {
    size: 10
  }));
};
var WebmailCell = (0, _styledComponents["default"])(_Grid["default"].Cell).withConfig({
  displayName: "Webmail__WebmailCell",
  componentId: "sc-itm1ju-0"
})(["", ""], (0, _emailUtils.mobileStyles)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n    display: block !important;\n    text-align: center !important;\n  "]))));
Webmail.defaultProps = {
  link: null
};
Webmail.propTypes = {
  link: _propTypes["default"].string
};
var _default = exports["default"] = Webmail;